/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    require('react-dnd'),DragDropMixin=$__0.DragDropMixin;

var Dustbin = React.createClass({displayName: 'Dustbin',
  mixins: [DragDropMixin],

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.ITEM, {
      dropTarget: {
        acceptDrop:function(item) {
          window.alert('You dropped ' + item.name + '!');
        }
      }
    });
  },

  render:function() {
    var dropState = this.getDropState(ItemTypes.ITEM),
        backgroundColor = '#222';

    if (dropState.isHovering) {
      backgroundColor = 'darkgreen';
    } else if (dropState.isDragging) {
      backgroundColor = 'darkkhaki';
    }

    return (
      React.createElement("div", React.__spread({},  this.dropTargetFor(ItemTypes.ITEM), 
           {style: {
             height: '12rem',
             width: '12rem',
             color: 'white',
             backgroundColor: backgroundColor,
             padding: '2rem',
             textAlign: 'center'
           }}), 

        dropState.isHovering ?
          'Release to drop' :
          'Drag item here'
        
      )
    );
  }
});

module.exports = Dustbin;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-simple/Dustbin.js
 ** module id = 144
 ** module chunks = 0
 **/